import * as React from "react";
import * as PopoverPrimitive from "@radix-ui/react-popover";
import { cn } from "../private/utils.js";

const Root = PopoverPrimitive.Root;
const Portal = PopoverPrimitive.Portal;
const Trigger = PopoverPrimitive.Trigger;
const Close = PopoverPrimitive.Close;

const Content = React.forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content> & {
    noPortal?: boolean;
  }
>(
  (
    { className, align = "center", sideOffset = 4, noPortal = false, ...props },
    ref
  ) => {
    if (noPortal) {
      return (
        <PopoverPrimitive.Content
          ref={ref}
          align={align}
          sideOffset={sideOffset}
          className={cn(
            "bg-mono-100 dark:bg-mono-950 text-mono-800 dark:text-mono-200 border-mono-200 dark:border-mono-700/50 bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 w-72 rounded-md border bg-white p-4 shadow-lg outline-hidden",
            className
          )}
          {...props}
        />
      );
    }
    return (
      <PopoverPrimitive.Portal>
        <PopoverPrimitive.Content
          ref={ref}
          align={align}
          sideOffset={sideOffset}
          className={cn(
            "bg-mono-100 dark:bg-mono-950 text-mono-800 dark:text-mono-200 border-mono-200 dark:border-mono-700/50 bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 w-72 rounded-md border bg-white p-4 shadow-lg outline-hidden",
            className
          )}
          {...props}
        />
      </PopoverPrimitive.Portal>
    );
  }
);
Content.displayName = PopoverPrimitive.Content.displayName;

const Popover = { Close, Root, Trigger, Content, Portal };

export { Popover };
